/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * Your Project
 * API for all things …
 * OpenAPI spec version: 1.0.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  Salary
} from '../../schema'


/**
 * Get Salary details
 */
export const retrieveSalary = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Salary>> => {
    return axios.get(
      `/salary/${id}`,options
    );
  }


export const getRetrieveSalaryQueryKey = (id: string,) => [`/salary/${id}`];

    
export type RetrieveSalaryQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveSalary>>>
export type RetrieveSalaryQueryError = AxiosError<unknown>

export const useRetrieveSalary = <TData = Awaited<ReturnType<typeof retrieveSalary>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveSalary>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRetrieveSalaryQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveSalary>>> = ({ signal }) => retrieveSalary(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof retrieveSalary>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Update Salary details
 */
export const updateSalary = (
    id: string,
    salary: Salary, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Salary>> => {
    return axios.put(
      `/salary/${id}`,
      salary,options
    );
  }



    export type UpdateSalaryMutationResult = NonNullable<Awaited<ReturnType<typeof updateSalary>>>
    export type UpdateSalaryMutationBody = Salary
    export type UpdateSalaryMutationError = AxiosError<unknown>

    export const useUpdateSalary = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSalary>>, TError,{id: string;data: Salary}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSalary>>, {id: string;data: Salary}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSalary(id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof updateSalary>>, TError, {id: string;data: Salary}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Delete a Salary
 */
export const destroySalary = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/salary/${id}`,options
    );
  }



    export type DestroySalaryMutationResult = NonNullable<Awaited<ReturnType<typeof destroySalary>>>
    
    export type DestroySalaryMutationError = AxiosError<unknown>

    export const useDestroySalary = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroySalary>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroySalary>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  destroySalary(id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof destroySalary>>, TError, {id: string}, TContext>(mutationFn, mutationOptions)
    }
    